import React from 'react';
import _FairDetail from './_FairDetail.scss';
import {Link} from 'react-router-dom';
import * as actions from 'actions/fairs';
import moment from 'moment';
import CONFIG from 'base/constants/config';

class FairInfo extends React.Component {

  render() {
    let Fair = this.props.data || {};
    let Categories = Fair.categories && Fair.categories.map((item, index) => {
      if(index === 0) {return item.name} else {return ' - ' + item.name}
    })
    return (
      <div>
        <div className='fair-box-content top-banner' style={{backgroundImage: `url(${CONFIG.API_URL}/containers/fairs/download/${Fair.banners && Fair.banners.length > 0 && Fair.banners[0]})`}}>
        </div>
        <div className='wrap-info'>
          <div className='info-items'>
            <h3 className='title' style={{fontWeight: 700}}>TÊN HỘI CHỢ</h3>
            <p className='info-content'>{Fair.name}</p>
          </div>
          <div className='info-items'>
            <h3 className='title' style={{fontWeight: 700}}>LĨNH VỰC</h3>
            <p className='info-content'>{Categories}</p>
            <p><Link to={`/fair/${Fair.id}/banner-category`} className='btn btn-category'>Quản lý banner danh mục</Link></p>
            <p><Link to={`/fair/${Fair.id}/ads`} className='btn btn-category'>Quản lý quảng cáo hội chợ</Link></p>
            <p><Link to={`/fair/${Fair.id}/email-invite`} className='btn btn-category'>Quản lý email mời doanh nghiệp</Link></p>
            <p><Link to={`/fair/${Fair.id}/email-approve`} className='btn btn-category'>Quản lý email duyệt doanh nghiệp</Link></p>
          </div>
          <div className='info-items'>
            <h3 className='title'></h3>
            <p className='info-content' style={{fontWeight: 700}}>THỜI GIAN BẮT ĐẦU</p>
            <p className='info-content'>{Fair.startDate ? moment(Fair.startDate).format('DD-MM-YYYY HH:mm') : ''}</p>
          </div>
          <div className='info-items'>
            <h3 className='title'></h3>
            <p className='info-content' style={{fontWeight: 700}}>THỜI GIAN KẾT THÚC</p>
            <p className='info-content'>{Fair.endDate ? moment(Fair.endDate).format('DD-MM-YYYY HH:mm') : ''}</p>
          </div>
          <div className='info-items' style={{textAlign: 'center'}}>
            <h3 className='title'></h3>
            <p className='info-content' style={{fontWeight: 700}}>TRẠNG THÁI</p>
            <p className={`${Fair.isPublish === true ? 'publish' : ''} status`}>{actions.checkFairCategory(Fair.status) || ''}{Fair.status === 0 ? (Fair.isPublish === true ? ' - Publish' : ' - Private') : ''}</p>
          </div>
        </div>
      </div>
    );
  }
}

export default FairInfo;



// WEBPACK FOOTER //
// ./components/fair/FairInfo.jsx